import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

function useSecondLookApplicationSubmitted(initialState: boolean = false) {
    const [isSecondLookApplicationSubmitted, setIsSecondLookApplicationSubmitted] =
        useState(initialState);
    return { isSecondLookApplicationSubmitted, setIsSecondLookApplicationSubmitted };
}

export const SecondLookApplicationSubmittedStore = createStore(useSecondLookApplicationSubmitted);
export type SecondLookApplicationSubmittedStore = ReturnType<
    typeof useSecondLookApplicationSubmitted
>;
